// eslint-disable-next-line import/no-anonymous-default-export
export default {
  home: {
    name: "Home",
    welcome: "Welcome to use the cloud to expand RPA management background!",
  },
};
